import { readFileSync } from "node:fs";
let cached = null;
// Best-effort. Used for ConnectionInit.clientVersion.
export const getSdkVersion = () => {
    if (cached !== null)
        return cached;
    try {
        // This file compiles to `dist/sdk/sdk-version.js`, so `../../package.json`
        // resolves to the published package's root package.json.
        const pkgUrl = new URL("../../package.json", import.meta.url);
        const raw = readFileSync(pkgUrl, "utf8");
        const parsed = JSON.parse(raw);
        if (typeof parsed === "object" && parsed !== null && "version" in parsed && typeof parsed.version === "string") {
            const version = parsed.version.trim();
            if (!version) {
                cached = undefined;
                return cached;
            }
            cached = version;
            return version;
        }
    }
    catch {
        // ignore
    }
    cached = undefined;
    return cached;
};
